export default "__VITE_ASSET__C1sGP65y__"